import documentResponseMaker from "./reponseMaker/documentResponseMaker";
import { isArray } from "underscore";
import System from "src/helper/system";
import Api from "./APIHandler";
import Product from "@system/config/product";
const API = new Api({});

class HomePageDocumentContentAPICall {

    getDocumentList = async (param, isAutoSearch) => {
        let res = {
            data: {}
        };
        param.search = param.search + "*"

        let d = {
            searchColumns: [""],
            search: param.search,
            searchType: "GlobalSearch",
            orderby: param.orderby ? param.orderby : "DocumentType asc",
            isIncludeCount: true,
            isSkipFacets: false,
            filter: "sboat eq '" + System.avUserInfoData.speedBoatAbbr + "'"
        }

        if (isAutoSearch) {
            d = { ...d, skip: 0, top: 5 }
        } else {
            d = { ...d, ...param }

            let filter = '';
            if (param.selectedFilterList?.length > 0) {
                let filterObj = {};
                param.selectedFilterList.map((v) => {
                    if (filterObj[v.fieldName] === undefined) {
                        filterObj[v.fieldName] = []; // prepare  field wise array
                    }
                    filterObj[v.fieldName].push(v.filterName);
                });
                if (Object.entries(filterObj).length > 0) {
                    Object.entries(filterObj).forEach((k, l) => {
                        k[1].forEach((i, j) => {
                            if (j === 0) {
                                if (filter.length) { // append if new key found
                                    filter += ' and ';
                                }
                                filter += 'search.in(' + Object.keys(filterObj)[l] + ',' + "'" + i + `${!k[1][j + 1] ? "'" : ""}`
                            } else {
                                filter += `|${i}${!k[1][j + 1] ? "'" : ""}`
                            }
                        });
                        filter += ",'|')";
                    });
                }
                filter = filter + ' and';
            }
            const dateRangeObject = param.dateRangeMomentObject;
            if (isArray(dateRangeObject) && dateRangeObject.length === 2) {
                let dateRangeObject_filter = '';
                if (filter !== '') {
                    dateRangeObject_filter = ' ';
                }
                if (dateRangeObject[0] && dateRangeObject[1]) {
                    dateRangeObject_filter += 'DatePublished ge ' + dateRangeObject[0] + ' and DatePublished le ' + dateRangeObject[1];
                }
                if (dateRangeObject_filter.length > 2) {
                    filter += dateRangeObject_filter + ' and'
                }
            }
            if (filter) {
                d.filter = filter + " sboat eq '" + System.avUserInfoData.speedBoatAbbr + "'";
            }
        }

        let reqData = {};
        delete d.dateRangeMomentObject
        delete d.selectedFilterList
        if (param.selectedFilterList?.length > 0) {
            d.filter = d.filter;
        }
        reqData.data = d;
        await API.post(Product.PRODUCT_DOCUMENT_LIST, reqData).then((resHer) => {
            res.data = resHer.data.Data
        });
        let result = await new documentResponseMaker(res, isAutoSearch);
        result = await result.process();
        return result.run().get();
    };

}

export default HomePageDocumentContentAPICall;